import { FC } from 'react';

interface SpinnerProps {
  className?: string;
  width?: string;
  height?: string;
  border?: string;
}

const Spinner: FC<SpinnerProps> = ({ className, width, height, border }) => {
  return (
    <div className='flex h-full items-center justify-center bg-white'>
      <div
        className={`${width ? width : 'w-14'} ${height ? height : 'h-14'} ${
          border ? border : 'border-4'
        }  animate-spin rounded-full  border-solid border-primary border-t-transparent`}
      ></div>
    </div>
  );
};

export default Spinner;
